import moment from "moment";
import { toast } from "react-toastify";
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const JSONParsing = (val: any) => {
  try {
    const res = JSON.parse(val);
    return res;
  } catch (error) {
    return val;
  }
};

export function debounce<T extends (...args: any[]) => void>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: NodeJS.Timeout | null;

  return function (...args: Parameters<T>) {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };
}

export function isValidEmail(email: string) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return !!emailRegex?.test?.(email);
}

export function handleError(message: any) {
  return (
    message?.data?.data?.custom_msg ??
    message?.data?.custom_msg ??
    message?.data?.data ??
    message?.data?.message ??
    message?.data ??
    message?.message ??
    message
  );
}

export function showError(message: string) {
  toast.error(`${handleError(message)}`);
}

export function showSuccess(message: string) {
  toast.success(`${message}`);
}

export function getLocalizedText(
  value: any,
  lang: "english" | "french" = "english"
): string {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "object") {
    const v = value[lang] ?? value.english ?? value.french;
    return v != null ? String(v) : "";
  }
  return String(value);
}

function stringToBoolean(value: any) {
  if (typeof value === "string") {
    const lower = value.toLowerCase();
    if (lower === "true") return true;
    if (lower === "false") return false;
  }
  return value;
}

export function createPayload(moduleKeys: any[], values: any) {
  const payload: any = {};

  moduleKeys.map((item) => {
    let value = values?.[item?.key];
    if (item?.type == "date" || item?.description == "date") {
      value = new Date(values?.[item?.key]).getTime();
    } else if (item?.description == "enum" || item?.type == "enum" || item?.type == "select") {
      value = values?.[item?.key]?.[item?.access_key || "value"] ?? values?.[item?.key] ?? "";
    } else if (item?.type == "varchar" || item?.description == "varchar") {
      value = values?.[item?.key]?.trim?.();
    } else if (item?.type == "number" || item?.description == "number") {
      value = Number(values?.[item?.key]);
      value = item?.vartype == "string" && value ? String(value) : value;
    } else if (item?.description == "boolean" || item?.type == "boolean") {
      value =
        stringToBoolean(values?.[item?.key]?.value) ??
        stringToBoolean(values?.[item?.key]) ??
        "";
    }

    if (
      item?.description == "boolean"
        ? typeof value == "boolean"
        : value && item?.key != "id"
    ) {
      payload[item?.key] = value;
    }
    if (item?.type == "phone" && value) {
      item?.childKeys?.map?.((childitem: any) => {
        let value = values?.[childitem?.key];
        payload[childitem?.key] = value;
      });
    }
  });
  return payload;
}

export function isValidURL(url: string) {
  try {
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol (optional)
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR IP (v4) address
        "(\\:\\d+)?" + // port (optional)
        "(\\/[-a-z\\d%@_.~+&:]*)*" + // path (optional)
        "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string (optional)
        "(\\#[-a-z\\d_]*)?$", // fragment identifier (optional)
      "i"
    );
    return !!pattern.test(url);
  } catch (error) {
    return false;
  }
}

export const validation = (value: any, type: string) => {
  switch (type?.toUpperCase?.()) {
    case "string":
      return value?.trim?.()?.length > 0;
    case "email":
      return EMAIL_PATTERN?.test?.(value?.trim?.());
    case "url":
      return isValidURL(value?.trim?.());
    case "phone":
      return !!Number(value);
    case "number":
      return !isNaN(value);
    case "int":
      return !isNaN(value);
    case "enum":
      return value?.trim?.()?.length > 0;
    case "select":
      return value?.trim?.()?.length > 0;
    case "date":
      return String(value)?.trim?.()?.length > 0;
    case "date_time":
      return String(value)?.trim?.()?.length > 0;
    case "varchar":
      return String(value)?.trim?.()?.length > 0;
    case "boolean":
      return typeof value === "boolean";
    default:
      return !!value;
  }
};

export function checkValue(moduleKeys: any[], values: any) {
  for (let index = 0; index < moduleKeys.length; index++) {
    const item = moduleKeys[index];
    if (item?.key == "id") {
      continue;
    }
    if (
      values?.[item?.key] &&
      !validation(values?.[item?.key], item?.description || item?.type)
    ) {
      return false;
    }
    if (
      item?.required && item?.description == "boolean"
        ? typeof values?.[item?.key] != "boolean"
        : !values?.[item?.key]
    ) {
      return false;
    }
  }
  return true;
}

export function getValue(item: any, payloadValues: any) {
  const data = payloadValues?.[item?.column];
  const value =
    item?.description == "enum"
      ? typeof data == "object"
        ? data
        : data
        ? { label: data, value: data }
        : null
      : data;
  return value;
}

export function toQueryString(obj: any = {}) {
  return Object.entries(obj)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]:any) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");
}
